export const INIT_LOADING_DEFAULT_TEMPLATES ="INIT_LOADING_DEFAULT_TEMPLATES"
export const END_LOADING_DEFAULT_TEMPLATES = "END_LOADING_DEFAULT_TEMPLATES"
export const GET_TEMPLATES = "GET_TEMPLATES"
export const ERROR = "ERROR"